module.exports = __webpack_public_path__ + "img/slovan.12005432.png";